(function($) {
	"use_strict";

	if ( $(window).width() < 768 ) {
		$('body').on('click', '.user-journey__nav-title', function() {
			$(this).toggleClass('open').next('.user-journey__nav-list').slideToggle(300);
		});
	}

}(jQuery));